export const searchTooltipText = 'Search by title';

export const deleteConfirmText = 'Are you sure you want to delete the milestone(s)?';

export const deleteConfirmDescription = 'Deleting the milestone(s) will remove all associated data, including progress and tasks linked to it.';
